import { Injectable } from '@angular/core';

import { Language } from 'src/app/tools/language/language';
import { TranslateService } from '@ngx-translate/core';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { DomainService } from 'src/app/services/domain/domain.service';

import { GlobalsService } from 'src/app/services/globals/globals.service';
import { WhoIsIpService } from 'src/app/services/who-is-ip/who-is-ip.service';

import { WindorefService } from 'src/app/services/window/windoref.service';
import { environment } from 'src/environments/environment';
import { searchSites } from 'src/app/enums/searchSites';
import { CookieService } from 'ngx-cookie-service';

const language: Language = new Language();

@Injectable({
  providedIn: 'root'
})
export class InitAppService {
  private typeLandingExpired: boolean;
  private site = environment.multisite.name;

  constructor(
    private _Translate: TranslateService,
    private _Storage: StoragePermissionService,
    private _Domain: DomainService,
    private _Global: GlobalsService,
    private _WhoIsIp: WhoIsIpService,
    private _Window: WindorefService,
    private _Cookie: CookieService
  ) {
    this.typeLandingExpired = this.checkTypeLandingExpired();
  }

  private checkTypeLandingExpired(): boolean {
    const typesLandingsExpired = this._Storage.getTypesLandingsExpired();
    return typesLandingsExpired.includes(this.site);
  }

  InitLanguage() {
    return language.inicializarLenguaje(this._Translate, this._Storage, this._Domain.getCurrentDomain());
  }

  SetClientOrigin(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._WhoIsIp.capitalizeClient('').then((res) => {
        resolve();
      });
    });
  }

  SetClientEnv(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._WhoIsIp.setEnvironment();
      resolve();
    });
  }

  CheckLandingUsage(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const isUpsell = this._Window.getNativeWindow().location.pathname.includes('upsell-');
      if (this.typeLandingExpired && this._Storage.isAlreadyUsed() && !isUpsell) {
        let { domainRedirect } = this._Domain.getCurrentDomain();
        this._Window.getNativeWindow().location.href = `${domainRedirect}`;
      }

      resolve();
    });
  }

  setSiteSource(): void {
    let ref = this._Global.removeHttp(document.referrer);
    //skip local domains (.co, .mx...)
    const totalRef = ref.split('.');
    if (totalRef.length > 2) {
      if (totalRef[0].length > 2) {
        ref = totalRef[0] + '.' + totalRef[1];
      } else {
        ref = totalRef[1] + totalRef[2];
      }
    }
    if (ref === '') {
      this._Cookie.set('site_source', 'direct', 1);
    } else {
      //Check if referrer is from our own site
      const domain_hit = ref.includes(this._Domain.getCurrentDomain().domain);
      if (!domain_hit) {
        let found = false;
        searchSites.forEach((el) => {
          if (el.url.indexOf(ref) > -1) {
            this._Cookie.set('site_source', el.name, 1);
            found = true;
          }
        });
        if (!found) {
          this._Cookie.set('site_source', 'external', 1);
        }
      } else {
        const site_source = this._Cookie.get('site_source');
        if (site_source === undefined || site_source === '' || site_source === null) {
          this._Cookie.set('site_source', 'direct', 1);
        }
      }
    }
  }
}
